import { ShieldCheck, Clock, Users, Award } from "lucide-react";
import { Button } from "@/components/ui/button";

const WHATSAPP_URL = "https://wa.me/5562986293474?text=Olá! Visitei o site da RL Refrigeração e gostaria de saber mais sobre a empresa.";

const DIFFERENTIALS = [
  {
    icon: ShieldCheck,
    title: "Garantia de Serviço",
    desc: "Todos os nossos serviços possuem garantia. Trabalhamos com peças originais e mão de obra qualificada.",
  },
  {
    icon: Clock,
    title: "Atendimento Rápido",
    desc: "Agilidade no atendimento com equipe pronta para emergências. Orçamento rápido e sem compromisso.",
  },
  {
    icon: Users,
    title: "Equipe Especializada",
    desc: "Técnicos treinados e certificados com anos de experiência em refrigeração residencial e industrial.",
  },
  {
    icon: Award,
    title: "Todas as Marcas",
    desc: "Trabalhamos com todas as marcas de ar condicionado e equipamentos de refrigeração do mercado.",
  },
];

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image + Stats */}
          <div className="relative">
            <div className="relative rounded-sm overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1729183672500-46c52a897de5?crop=entropy&cs=srgb&fm=jpg&q=80&w=800"
                alt="Equipe RL Refrigeração trabalhando"
                className="w-full h-[400px] lg:h-[500px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0C4A6E]/60 to-transparent" />
            </div>
            {/* Floating stats card */}
            <div className="absolute -bottom-6 -right-4 lg:right-4 bg-[#0E86D4] text-white p-6 rounded-sm shadow-xl max-w-[200px]">
              <div className="text-5xl font-extrabold font-['Barlow_Condensed']">9+</div>
              <div className="text-sm font-medium mt-1 text-white/90 font-['Manrope']">
                Anos de experiência no mercado
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <span className="inline-block bg-[#E0F2FE] text-[#0E86D4] text-xs font-bold tracking-[0.2em] uppercase px-4 py-1.5 font-['Barlow_Condensed']">
              Sobre nós
            </span>
            <h2
              data-testid="about-title"
              className="mt-4 text-3xl md:text-4xl font-extrabold text-[#0F172A] font-['Barlow_Condensed'] uppercase tracking-tight"
            >
              Por Que Escolher a<br />
              <span className="text-[#0E86D4]">RL Refrigeração?</span>
            </h2>
            <p className="mt-4 text-base text-[#64748B] leading-relaxed font-['Manrope']">
              Fundada em 2016, a RL Refrigeração é referência em Goiânia na instalação e manutenção de sistemas de refrigeração. 
              Nossa equipe de técnicos especializados atende residências, comércios, hospitais e indústrias com 
              excelência e compromisso com a qualidade.
            </p>

            {/* Differentials grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-8">
              {DIFFERENTIALS.map((item, idx) => {
                const Icon = item.icon;
                return (
                  <div
                    key={item.title}
                    data-testid={`differential-${idx}`}
                    className="flex gap-3"
                  >
                    <div className="flex-shrink-0 w-10 h-10 bg-[#F0F9FF] rounded-sm flex items-center justify-center">
                      <Icon className="w-5 h-5 text-[#0E86D4]" strokeWidth={2} />
                    </div>
                    <div>
                      <h3 className="text-sm font-bold text-[#0F172A] font-['Barlow_Condensed'] uppercase tracking-tight">
                        {item.title}
                      </h3>
                      <p className="text-xs text-[#64748B] mt-0.5 leading-relaxed font-['Manrope']">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-block mt-8">
              <Button
                data-testid="about-cta"
                className="bg-[#0E86D4] hover:bg-[#0284C7] text-white font-['Barlow_Condensed'] uppercase tracking-wider text-sm font-bold rounded-sm px-8 py-5"
              >
                Fale Com Nossa Equipe
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
